import React from 'react';
import { Component } from 'react';

export class Rain  extends Component {
render(){
  return (
    <div className="Icon">
     <svg version="1.1" id="rain" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24">
<rect fillRule="evenodd" clipRule="evenodd" fill="none" width="24" height="24"/>
<g>
	<path fillRule="evenodd" clipRule="evenodd" fill="#FFFFFF" d="M5.25,15.5c-1.5166,0-2.75-1.2334-2.75-2.75
		c0-1.1265,0.6777-2.127,1.7266-2.5483l0.3506-0.1406l-0.04-0.3755C4.5137,9.4609,4.5,9.2324,4.5,9c0-3.584,2.916-6.5,6.5-6.5
		c2.9912,0,5.583,2.0288,6.3018,4.9331l0.0908,0.3677l0.3789,0.0117C19.8623,7.8789,21.5,9.5645,21.5,11.6499
		c0,2.123-1.7275,3.8501-3.8506,3.8501H5.25z"/>
	<path fill="#1D1D33" d="M10.9998,3c2.761,0,5.1527,1.8724,5.8163,4.5532l0.182,0.7354l0.7571,0.0239
		c1.8194,0.0575,3.2446,1.5236,3.2446,3.3375c0,1.8472-1.5028,3.35-3.35,3.35h-12.4c-1.2407,0-2.25-1.0094-2.25-2.25
		c0-0.921,0.5546-1.739,1.413-2.0841l0.6991-0.281L5.0345,9.6353C5.0111,9.4091,4.9998,9.2013,4.9998,9
		C4.9998,5.6917,7.6914,3,10.9998,3 M10.9998,2c-3.866,0-7,3.1331-7,7c0,0.25,0.015,0.496,0.04,0.738
		c-1.194,0.48-2.04,1.645-2.04,3.012c0,1.7939,1.455,3.25,3.25,3.25h12.4c2.403,0,4.35-1.948,4.35-4.35
		c0-2.3561-1.875-4.2631-4.213-4.337C17.0318,4.2629,14.2838,2,10.9998,2L10.9998,2z"/>
</g>
<path fillRule="evenodd" clipRule="evenodd" fill="#0072F5" d="M11.5342,19.04c-0.0645,0-0.1289-0.0122-0.1914-0.0381
	c-0.2549-0.1055-0.376-0.3984-0.2705-0.6533l0.4785-1.1548c0.1064-0.2559,0.4014-0.375,0.6533-0.2705
	c0.2549,0.1055,0.376,0.3984,0.2705,0.6533l-0.4785,1.1548C11.916,18.9238,11.7305,19.04,11.5342,19.04z M8.2598,18.7314
	l0.4785-1.1548c0.1055-0.2549-0.0156-0.5479-0.2705-0.6533c-0.2529-0.1045-0.5469,0.0146-0.6533,0.2705l-0.4785,1.1548
	c-0.1055,0.2549,0.0156,0.5479,0.2705,0.6533c0.0625,0.0259,0.127,0.0381,0.1914,0.0381C7.9941,19.04,8.1797,18.9238,8.2598,18.7314
	z M9.4062,21.6021l0.4785-1.1548c0.1055-0.2549-0.0156-0.5479-0.2705-0.6533c-0.2539-0.105-0.5469,0.0151-0.6533,0.2705
	l-0.4785,1.1548c-0.1055,0.2549,0.0156,0.5479,0.2705,0.6533c0.0625,0.0259,0.127,0.0381,0.1914,0.0381
	C9.1406,21.9106,9.3262,21.7944,9.4062,21.6021z M5.6631,21.6016l0.4775-1.1548c0.1055-0.2549-0.0156-0.5474-0.2705-0.6528
	c-0.2549-0.106-0.5488,0.0156-0.6533,0.271l-0.4775,1.1548c-0.1055,0.2549,0.0156,0.5474,0.2705,0.6528
	c0.0625,0.0259,0.1279,0.0381,0.1914,0.0381C5.3975,21.9106,5.584,21.7944,5.6631,21.6016z M4.5244,18.7314l0.4785-1.1553
	c0.1055-0.2554-0.0156-0.5479-0.2705-0.6533c-0.2559-0.1064-0.5469,0.0156-0.6533,0.2705l-0.4785,1.1553
	c-0.1055,0.2554,0.0156,0.5479,0.2705,0.6533C3.9336,19.0278,3.999,19.04,4.0625,19.04C4.2588,19.04,4.4443,18.9238,4.5244,18.7314z
	 M19.4678,18.7314l0.4785-1.1548c0.1055-0.2549-0.0156-0.5479-0.2705-0.6533c-0.2529-0.1045-0.5469,0.0146-0.6533,0.2705
	l-0.4785,1.1548c-0.1055,0.2549,0.0156,0.5479,0.2705,0.6533c0.0625,0.0259,0.127,0.0381,0.1914,0.0381
	C19.2021,19.04,19.3877,18.9238,19.4678,18.7314z M15.7314,18.7314l0.4785-1.1548c0.1055-0.2549-0.0156-0.5479-0.2705-0.6533
	c-0.252-0.1045-0.5469,0.0146-0.6533,0.2705l-0.4785,1.1548c-0.1055,0.2549,0.0156,0.5479,0.2705,0.6533
	c0.0625,0.0259,0.127,0.0381,0.1914,0.0381C15.4658,19.04,15.6514,18.9238,15.7314,18.7314z M16.8945,21.6016l0.4775-1.1548
	c0.1055-0.2549-0.0156-0.5474-0.2705-0.6528c-0.2549-0.106-0.5479,0.0156-0.6533,0.271l-0.4775,1.1548
	c-0.1055,0.2549,0.0156,0.5474,0.2705,0.6528c0.0625,0.0259,0.1279,0.0381,0.1914,0.0381
	C16.6289,21.9106,16.8154,21.7944,16.8945,21.6016z M13.1504,21.6021l0.4785-1.1548c0.1055-0.2549-0.0156-0.5479-0.2705-0.6533
	c-0.2529-0.105-0.5469,0.0151-0.6533,0.2705l-0.4785,1.1548c-0.1055,0.2549,0.0156,0.5479,0.2705,0.6533
	c0.0625,0.0259,0.127,0.0381,0.1914,0.0381C12.8848,21.9106,13.0703,21.7944,13.1504,21.6021z"/>
</svg>

    </div>
  );
}
}
export default Rain;